export const submenu = state => state.submenu
export const DiscountSwitchData = state => state.DiscountSwitchData
